jQuery(document).ready(function($) {
  // Mobile navi
  $('button.hamburger').click(function() {
    $(this).find('span#nav-icon').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('navi-open');
    if ( $('body.navi-open').length > 0 ) {
      //$('nav.main-navi').slideDown(300);
      $('nav.main-navi').show();
      $(this).attr('aria-expanded', 'true');
    }
    else {
      $('nav.main-navi').hide();
      $(this).attr('aria-expanded', 'false');
    }
  });

  $('nav.main-navi .submenu-toggle').click(function() {
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', String(!expanded));
  });

  // Avautuva sisältö
  $('a.accordion-title').click(function(e) {
    e.preventDefault();
    var elm = $(this).next();
    var parent = $(this).parent();
    var parent_class_changed = false;
    $('div.accordion-content-wrap').not(elm).slideUp();
    $('a.accordion-title').not(this).removeClass('open');
    $('div.accordion-item').not(parent).removeClass('open');
    $(this).toggleClass('open');
    if (!parent.hasClass('open')) {
      parent.toggleClass('open');
      parent_class_changed = true;
    }
    elm.slideToggle(function() {
      if (!parent_class_changed)
        parent.toggleClass('open');
    });
  });

  // Galleria

  var galleryLinks = document.querySelectorAll('.gallery a');
  if (galleryLinks.length > 0) {

    var numLinks = galleryLinks.length;
    var currentLink = 0;

    // Create the modal
    var modal = document.createElement('div');
    modal.classList.add('modal');
    modal.innerHTML = `
      <img class="modal-image" />
      <div class="modal-title"></div>
      <a class="modal-download" href="" download>Lataa kuva</a>
      <div class="modal-counter"></div>
      <div class="modal-prev">&#10094;</div>
      <div class="modal-next">&#10095;</div>
    `;
    document.body.appendChild(modal);

    var modalImage = modal.querySelector('.modal-image');
    var modalTitle = modal.querySelector('.modal-title');
    var modalDownload = modal.querySelector('.modal-download');
    var modalCounter = modal.querySelector('.modal-counter');
    var modalPrev = modal.querySelector('.modal-prev');
    var modalNext = modal.querySelector('.modal-next');

    // Show the modal when a link is clicked
    galleryLinks.forEach(function(link, index) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        currentLink = index;
        showModal(currentLink);
      });
    });

    // Show the modal with the current image
    function showModal(index) {
      var href = galleryLinks[index].getAttribute('href');
      var title = galleryLinks[index].getAttribute('title');
      var counter = (index + 1) + '/' + numLinks;
      modalImage.setAttribute('src', href);
      modalTitle.textContent = title;
      modalDownload.setAttribute('href', href);
      modalCounter.textContent = counter;
      modal.style.display = 'block';
    }

    // Hide the modal when the background is clicked
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });

    // Show the previous image
    modalPrev.addEventListener('click', function() {
      currentLink--;
      if (currentLink < 0) {
        currentLink = numLinks - 1;
      }
      showModal(currentLink);
    });

    // Show the next image
    modalNext.addEventListener('click', function() {
      currentLink++;
      if (currentLink >= numLinks) {
        currentLink = 0;
      }
      showModal(currentLink);
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowLeft') {
        currentLink--;
        if (currentLink < 0) {
          currentLink = numLinks - 1;
        }
        showModal(currentLink);
      } else if (event.key === 'ArrowRight') {
        currentLink++;
        if (currentLink >= numLinks) {
          currentLink = 0;
        }
        showModal(currentLink);
      } else if (event.key === 'Escape') {
        modal.style.display = 'none';
      }
    });

    // Pop-up functionality
    var popUpSection = document.querySelector('section.pop-up');
    if (popUpSection) {
      var popUpItems = document.querySelectorAll('.pop-up-item');
      popUpItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          var popupContent = item.querySelector('.pop-up-content').cloneNode(true);
          var popupBg = document.createElement('div');
          popupBg.classList.add('popup-bg');
          document.body.appendChild(popupBg);
          document.body.appendChild(popupContent);
          var closeBtn = document.createElement('a');
          closeBtn.setAttribute('href', '#');
          closeBtn.classList.add('close');
          closeBtn.textContent = 'Sulje';
          popupContent.appendChild(closeBtn);
          popupContent.style.top = (window.scrollY + window.innerHeight * 0.1) + 'px';
          popupBg.style.display = 'block';
          popupContent.style.display = 'block';

          // Close pop-up
          popupBg.addEventListener('click', closePopup);
          closeBtn.addEventListener('click', closePopup);
        });
      });

      function closePopup(e) {
        e.preventDefault();
        var popupBg = document.querySelector('.popup-bg');
        var popupContent = document.querySelector('body > .pop-up-content');
        if (popupBg) popupBg.remove();
        if (popupContent) popupContent.remove();
      }
    }
  }

  // Galleria END

  // Avautuvan sisällön avaaminen linkistä

  function openAccordionFromHash() {
    var hash = window.location.hash;
    if (!hash) {
      return;
    }
    var target = $(hash);
    if (!target.length) {
      return;
    }
    var title = target.find('> .accordion-title');
    var content = target.find('> .accordion-content-wrap');
    if (!title.length || !content.length) {
      return;
    }
    // Sulje muut
    $('div.accordion-content-wrap').not(content).hide();
    $('a.accordion-title').not(title).removeClass('open');
    $('div.accordion-item').not(target).removeClass('open');
    // Avaa oikea
    title.addClass('open');
    target.addClass('open');
    content.show();
    // Scrollataan hieman nätimmin kohdalle
    $('html, body').animate({
      scrollTop: target.offset().top - 100
    }, 300);
  }
  // Ajetaan sivun latauksessa
  openAccordionFromHash();
  // Ja jos hash muuttuu (esim. sisäinen linkki)
  $(window).on('hashchange', openAccordionFromHash);

  // Avautuvan sisällön avaaminen linkistä END

}); // jQuery(document).ready

// Sticky header
(function () {
  const win = window;
  const body = document.body;
  let ticking = false;
  const stickyOffset = 150;
  function onScroll() {
    const scrollTop = win.pageYOffset || document.documentElement.scrollTop;
    const isSticky = scrollTop > stickyOffset;
    if (isSticky !== body.classList.contains('sticky-header')) {
      body.classList.toggle('sticky-header', isSticky);
    }
    ticking = false;
  }
  win.addEventListener('scroll', function () {
    if (!ticking) {
      win.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();

// Yksittäisen kuvan suurentaminen
// Simple lightbox (valituille kuville)
(function () {
  const links = document.querySelectorAll('a.suurenna');
  if (!links.length) return;
  // Luo lightbox DOM
  const lightbox = document.createElement('div');
  lightbox.classList.add('lightbox');
  lightbox.innerHTML = `
    <div class="lightbox-inner">
      <button class="lightbox-close" aria-label="Sulje">&times;</button>
      <img src="" alt="">
    </div>
  `;
  document.body.appendChild(lightbox);
  const img = lightbox.querySelector('img');
  // Klikkaus
  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      img.src = this.href;
      lightbox.classList.add('open');
    });
  });
  // Sulku klikillä
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      lightbox.classList.remove('open');
    }
  });
  // ESC sulku
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      lightbox.classList.remove('open');
    }
  });
  // Sulku rastista
  const closeBtn = lightbox.querySelector('.lightbox-close');
  closeBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    lightbox.classList.remove('open');
  });
})();

// Animoitu ankkuriscroll nuoli-listalle
(function () {
  const arrowListLinks = document.querySelectorAll('ul.nuoli-lista a[href^="#"]');
  if (!arrowListLinks.length) {
    return;
  }
  function getHeaderOffset() {
    const header = document.querySelector('header#top');
    if (!header) {
      return 0;
    }
    return header.offsetHeight || 0;
  }
  arrowListLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (!targetId || targetId === '#') {
        return;
      }
      const targetElement = document.querySelector(targetId);
      if (!targetElement) {
        return;
      }
      e.preventDefault();
      const headerOffset = getHeaderOffset();
      const extraOffset = 0; // pieni lisätila headerin alle, jos tarvii
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerOffset - extraOffset;
      window.scrollTo({
        behavior: 'smooth',
        top: targetPosition
      });
    });
  });
})();

// Kääntyvät kortit
document.addEventListener('DOMContentLoaded', function () {
  const flipCards = document.querySelectorAll('.js-flip-card');
  if (!flipCards.length) {
    return;
  }
  const tabletBreakPoint = 1050;
  function isTabletOrSmaller() {
    return window.innerWidth <= tabletBreakPoint;
  }
  flipCards.forEach(function (card) {
    const closeBtn = card.querySelector('.flip-card__close');
    card.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      flipCards.forEach(function (otherCard) {
        if (otherCard !== card) {
          otherCard.classList.remove('is-flipped');
        }
      });
      card.classList.toggle('is-flipped');
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        if (!isTabletOrSmaller()) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        card.classList.remove('is-flipped');
      });
    }
  });
});

// Avoimet työpaikat -filtterit
(function () {
  const filterWrap = document.querySelector('.js-job-filters');
  const jobsWrap = document.querySelector('.js-jobs-wrap');

  if (!filterWrap || !jobsWrap) {
    return;
  }

  const filterLinks = filterWrap.querySelectorAll('a[data-filter-type]');
  const jobItems = jobsWrap.querySelectorAll('.js-job-item');
  const emptyMessage = document.querySelector('.js-jobs-empty-message');

  let activeDepartment = 'all';
  let activeLocation = 'all';

  function updateActiveStates(type, clickedLink) {
    const links = filterWrap.querySelectorAll('a[data-filter-type="' + type + '"]');

    links.forEach(function (link) {
      link.classList.remove('is-active');
    });

    clickedLink.classList.add('is-active');
  }

  function filterJobs() {
    let visibleCount = 0;

    jobItems.forEach(function (jobItem) {
      const department = jobItem.getAttribute('data-department') || '';
      const locations = jobItem.getAttribute('data-locations') || '';

      const departmentMatch =
        activeDepartment === 'all' || department === activeDepartment;

      const locationMatch =
        activeLocation === 'all' || locations.split(' ').includes(activeLocation);

      if (departmentMatch && locationMatch) {
        jobItem.style.display = '';
        visibleCount++;
      } else {
        jobItem.style.display = 'none';
      }
    });

    if (emptyMessage) {
      emptyMessage.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  }

  filterLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const type = this.getAttribute('data-filter-type');
      const value = this.getAttribute('data-filter-value');

      if (type === 'department') {
        activeDepartment = value;
        updateActiveStates('department', this);
      }

      if (type === 'location') {
        activeLocation = value;
        updateActiveStates('location', this);
      }

      filterJobs();
    });
  });

  filterJobs();
})();

// Smooth scroll ankkurilinkeille (.btn)
(function () {
  const links = document.querySelectorAll('a.btn[href^="#"]');

  if (!links.length) {
    return;
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');

      // Estetään pelkkä "#"
      if (!targetId || targetId === '#') {
        return;
      }

      const targetEl = document.querySelector(targetId);

      // Jos target löytyy samalta sivulta
      if (targetEl) {
        e.preventDefault();

        // Jos sinulla on sticky header, säädä tätä:
        const headerOffset = 80; // px

        const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
})();

// Single post kuvakaruselli
document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.js-post-image-carousel');

  if (!carousels.length) {
    return;
  }

  carousels.forEach(function (carousel) {
    const slides = carousel.querySelectorAll('.post-image-carousel__slide');
    const prevBtn = carousel.querySelector('.post-image-carousel__button--prev');
    const nextBtn = carousel.querySelector('.post-image-carousel__button--next');
    let currentIndex = 0;

    if (slides.length < 2) {
      return;
    }

    function showSlide(index) {
      slides[currentIndex].classList.remove('is-active');
      currentIndex = index;
      slides[currentIndex].classList.add('is-active');
    }

    function showPrev() {
      const nextIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
      showSlide(nextIndex);
    }

    function showNext() {
      const nextIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
      showSlide(nextIndex);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showNext();
      });
    }
  });
});

// Complianz evästelista aina avoinna
document.addEventListener('DOMContentLoaded', function () {
  const cookieDetails = document.querySelectorAll(
    '#cmplz-cookies-overview details.cmplz-dropdown-cookiepolicy'
  );

  cookieDetails.forEach(function (details) {
    details.open = true;

    details.addEventListener('toggle', function () {
      if (!details.open) {
        details.open = true;
      }
    });
  });
});